<button mat-button [matMenuTriggerFor]="menu">
  {{ title() }}
  <mat-icon>keyboard_arrow_down</mat-icon>
</button>

<mat-menu class="menu" #menu="matMenu">
  <ng-template matMenuContent let-name="name">
    <app-dropdown-search placeholder="Search views" (changed)="getQuery($event)" />

    @for (option of filteredOptions(); track $index) {
    <button mat-menu-item [class.active]="activeValue() === $index" (click)="changed.emit(option.value)">
      {{ option.title }}
    </button>
    }
  </ng-template>
</mat-menu>